import type { ComputedRef, InjectionKey } from 'vue'
import type { WebsiteLink } from './types'

export interface WebsiteLinkSelection {
  link: WebsiteLink
  anchor: {
    top: number
    right: number
    bottom: number
    left: number
    width: number
    height: number
  }
}

export interface WebsiteEditableContext {
  editable: ComputedRef<boolean>
  contentChanged: () => void
  linkSelected: (selection: WebsiteLinkSelection) => void
}

export const websiteEditableContextKey: InjectionKey<WebsiteEditableContext> = Symbol('website-editable-context')
